/* eslint-disable no-use-before-define */
import React from 'react'
import { Flyout, arraySplit, show } from '../../twd'

export default ({invType}) => {

    let invTypeText = {
        'C': 'Corporates',
        'M': 'Municipals',
        'S': 'CDs',
        'T': 'U.S. Treasuries',
        'A': 'Agencies'
    }[invType] || ''

    let searches = Searches.filter((s) => s.invType===invType)

    let tip = ['<ul>Predefined Searches for ', invTypeText]
            .concat(searches.map((a) => `<li><u>${a.label}</u>: ${a.tip}</li>`))
            .concat('</ul>')
            .join('')

    return <React.Fragment>
    <div className="row vertical-offset-base">
    <div className="col-md-12">
        <Flyout
            label="Predefined Searches"
            className="btn-label btn-flyout tiny-header vertical-offset-xs"
            dataName="overview-predefined-searches-info"
            html={tip}
        />
    </div>
    <div className="col-md-12">{
        arraySplit(searches,2)
        .map((arr,i) => {
            let [a,b] = arr

            return <div key={i} className="row">
                { a && <div className="col-md-6 col-xs-12 vertical-offset-xs">
                <button
                    data-name="predefined-searches-row"
                    className="link-button text-left"
                    onClick={() => onSearch(a.searchParams, a.show)}
                >{a.label}</button>
                </div>}

                { b && <div className="col-md-6 col-xs-12 vertical-offset-xs">
                <button
                    data-name="predefined-searches-row"
                    className="link-button text-left"
                    onClick={() => onSearch(b.searchParams, b.show)}
                >{b.label}</button>
                </div>}
            </div>
        })
    }
    </div>
    </div>
    </React.Fragment>
}

const onSearch = (sp, nav) => {
    if (nav) return show(nav)
    if (!sp) return

    show('offerings', {
        searchParams: Object.assign({
            persistToPreviousSearches: false
        },sp),
        _ts: Date.now(),
        from:'overview'
    })
}


const Searches = [{
    invType: 'C',
    label: 'High-Yield, Medium Term',
    tip:`This category features high yield (includes ratings between C/C – Ba1/BB+)
        corporate bonds with a minimum 7% coupon rate, maturities ranging
        between 5 and 10 years, and a semi-annual payment frequency.
        All results displayed are from dealers offering a minimum of 10 bonds,
        with an offering price between 95 and 120.`,
    searchParams: {
        holdInvType: ['C'],
        holdMoodyRatingMin: 'C',
        holdMoodyRatingMax: 'Ba1',
        holdSpRatingMin: 'C',
        holdSpRatingMax: 'BB+',
        holdCouponMin: 7,
        holdMaturityMin: '5y',
        holdMaturityMax: '10y',
        holdCouponPayFrequency: ['S'],
        clientPriceMin: 95,
        clientPriceMax: 120,
        quantityMin: 10,
        holdCallableInd: ['N'],
        holdConvertible: ['N'],
        holdCouponTypeCode: ['FNZR'],
        offeringType: ['secondary','ask-side'],
        primarySecondary: ['secondary'],
    }
}, {
    invType: 'C',
    label: 'New Issue Corp Notes',
    tip: `This category features new issue corporate notes.`,
    searchParams: {
        holdInvType: ['C'],
        offeringType: ['primary','ask-side'],
        primarySecondary: ['primary'],
    }
}, {
    invType: 'C',
    label: 'Convertibles',
    tip: `This category features convertible corporate bonds.`,
    searchParams: {
        holdInvType: ['C'],
        holdConvertible: ['Y'],
        offeringType: ['secondary','ask-side'],
        primarySecondary: ['secondary'],
    }
}, {
    invType: 'C',
    label: 'Step-Ups',
    tip: `This category features investment grade (Baa3/BBB- and above)
        corporate bonds with step-up coupon rates. Non-callable bonds
        and those featuring a make-whole call provision are included.`,
    searchParams: {
        holdInvType: ['C'],
        holdMoodyRatingMin: 'Baa3',
        holdSpRatingMin: 'BBB-',
        holdCouponTypeCode: ['MULTI-STEP'],
        holdCallableInd: ['N'],
        holdWholeCallInd: ['Y'],
        offeringType: ['secondary','ask-side'],
        primarySecondary: ['secondary'],
    }
}, {
    invType: 'M',
    label: 'Nationals Priced Near Par',
    tip: `This category features investment grade (Baa3/BBB- and above)
        municipal bonds with a minimum 4% coupon and minimum yield-to-worst
        of 1% available across all US states.  All bonds feature maturities
        ranging between 5 and 10 years, and a semi-annual payment frequency.
        All results displayed are from dealers offering a minimum of 10 bonds,
        with an offering price between 95 and 105.`,
    searchParams: {
        holdInvType: ['M'],
        holdMoodyRatingMin: 'Baa3',
        holdSpRatingMin: 'BBB-',
        holdCouponMin: 4,
        offerYtwMin: 1,
        ytwMin: 1,
        holdMaturityMin: '5y',
        holdMaturityMax: '10y',
        holdCouponPayFrequency: ['S'],
        clientPriceMin: 95,
        clientPriceMax: 105,
        quantityMin: 10,
        holdCouponTypeCode: ["FNZR"],
        holdTaxable: ['N'],
        holdStateTaxExempt: ['Y'],
        holdAltMinTax: ['N'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'M',
    label: 'Pre-Refunded, Short-Term',
    tip: `This category features investment grade (Baa3/BBB- and above)
        pre-refunded municipal bonds with maturities ranging between 1 and 5 years,
        and a semi-annual payment frequency. All results displayed are from dealers
        offering a minimum of 10 bonds, with an offering price between 95 and 120.`,
    searchParams: {
        holdInvType: ['M'],
        holdMoodyRatingMin: 'Baa3',
        holdSpRatingMin: 'BBB-',
        holdRefundInd: ['Y'],
        holdRefundType: ['PRE'],
        holdMaturityMin: '1y',
        holdMaturityMax: '5y',
        holdCouponPayFrequency: ['S'],
        quantityMin: 10,
        clientPriceMin: 95,
        clientPriceMax: 120,
        holdTaxable: ['N'],
        holdStateTaxExempt: ['Y'],
        holdAltMinTax: ['N'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'M',
    label: 'Zeroes, Medium-Term',
    tip: `This category features investment grade (Baa3/BBB- and above)
        zero coupon municipal bonds with maturities ranging between 5 and 10 years,
        and semi-annual interest payments. All results displayed are
        from dealers offering a minimum of 10 bonds.`,
    searchParams: {
        holdInvType: ['M'],
        holdMoodyRatingMin: 'Baa3',
        holdSpRatingMin: 'BBB-',
        holdCouponTypeCode: ['ZR'],
        holdMaturityMin: '5y',
        holdMaturityMax: '10y',
        holdCouponPayFrequency: ['S'],
        quantityMin: 10,
        holdTaxable: ['N'],
        holdStateTaxExempt: ['Y'],
        holdAltMinTax: ['N'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'M',
    label: 'Green Bonds',
    tip: `This category includes municipal bonds classified as green bonds,
        clean renewable energy bonds or qualified energy conservation bonds.`,
    searchParams: {
        holdInvType: ['M'],
        holdIssueType: ['Envrnmntl', 'Green', 'NCREB', 'NCRED', 'QECB', 'QECBD'],
        holdTaxable: ['N'],
        holdStateTaxExempt: ['Y'],
        holdAltMinTax: ['N'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'T',
    label: 'T-Bills',
    tip:  `This category includes US Treasury Bills with maturities up to one year.`,
    searchParams: {
        holdInvType: ['T'],
        holdTreasuryType: ['Bills'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'T',
    label: 'T-Notes',
    tip: `This category includes US Treasury Notes with maturities ranging
        from 2 to 10 years.`,
    searchParams: {
        holdInvType: ['T'],
        holdTreasuryType: ['Notes'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'T',
    label: 'Inflation-Protected TIPS',
    tip: `This category includes Treasury Inflation-Protected Securities.`,
    searchParams: {
        holdInvType: ['T'],
        holdTreasuryType: ['TIPS'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'T',
    label: 'Zeroes, Short-term',
    tip: `This category includes short-term zero-coupon treasury bonds (STRIPS)
        with maturities ranging between 1 to 5 years.`,
    searchParams: {
        holdInvType: ['T'],
        holdTreasuryType: ['STRIPS'],
        holdMaturityMin: '1y',
        holdMaturityMax: '5y',
        offeringType: ['ask-side'],
    }
}, {
    invType: 'T',
    label: 'New Issue Auctions',
    tip: 'This category includes new issue Treasury Auctions.',
    show: 'tools.treasury-auctions'
}, {
    invType: 'S',
    label: 'New Issue, Short-Term',
    tip: `This category includes short-term new issue CDs with maturities
        up to one year.`,
    searchParams: {
        holdInvType: ['S'],
        holdMaturityMax: '1y',
        offeringType: ['primary','ask-side'],
        primarySecondary: ['primary'],
    }
}, {
    invType: 'S',
    label: 'New Issue, Medium-Term',
    tip: `This category includes medium-term new issue CDs with maturities
        ranging between 1 and 3 years.`,
    searchParams: {
        holdInvType: ['S'],
        holdMaturityMin: '1y',
        holdMaturityMax: '3y',
        offeringType: ['primary','ask-side'],
        primarySecondary: ['primary'],
    }
}, {
    invType: 'S',
    label: 'Monthly Coupon Payers',
    tip: 'This category includes CDs only with monthly interest payments',
    searchParams: {
        holdInvType: ['S'],
        holdCouponPayFrequency: ['M'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'S',
    label: 'Step-ups',
    tip: 'This category includes CDs with step-up coupons.',
    searchParams: {
        holdInvType: ['S'],
        holdCouponTypeCode: ['MULTI-STEP'],
        offeringType: ['ask-side'],
    }
}, {
    invType: 'A',
    label: 'Tax-Advantaged',
    tip: `This category includes tax-advantaged agency bonds issued by
        the Federal Home Loan Banks (FHLB), Federal Farm Credit Banks (FFCB)
        and the Tennessee Valley Authority (TVA).`,
    searchParams: {
        holdInvType: ['A'],
        holdAgencyType: ['FHLB', 'FFCB', 'TVA'],
        offeringType: ['ask-side'],
    }

}]